import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";
import Button from "../../base/Button";
import { useDispatch, useSelector } from "../../../store";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../base/Breadcrumbs";
import { setSelectedDashboard } from "../../../slices/dashboard";
import { toggleEditMode } from "../../../slices/shared";
import { getBreadcrumbs, selectTile } from "../../../slices/tile";
import checkRole, { UserRoles } from "../../../helpers/checkRole";

interface Props {
  id: number;
}

const DashboardHeaderView: React.FC<Props> = (props) => {
  const { id } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { editMode } = useSelector((store) => store.shared);
  const { loggedInUser } = useSelector((store) => store.auth);
  const { homeDashboard, currentDashboard } = useSelector(
    (store) => store.dashboard
  );

  const { breadcrumbs } = useSelector((store) => store.tiles);

  useEffect(() => {
    const titleTile = currentDashboard?.titleTileId;

    if (titleTile) {
      dispatch(getBreadcrumbs(titleTile));
    }

    return () => {
      dispatch(toggleEditMode(false));
    };
  }, [dispatch, id, homeDashboard?.titleTileId, currentDashboard?.titleTileId]);

  return (
    <Box display="flex" flexDirection="row" width="100%">
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
        marginX={3}
      >
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          width="100%"
        >
          <Box display="flex" flexDirection="column">
            {!!id && id !== homeDashboard?.id && !!breadcrumbs?.length && (
              <Breadcrumbs breadcrumbs={breadcrumbs!} />
            )}
          </Box>
          <Box display="flex" flexDirection="column">
            <Box
              display="flex"
              flexDirection="row"
              gap={2}
              visibility={
                editMode && checkRole(loggedInUser!, UserRoles.AnyAdmin)
                  ? "visible"
                  : "hidden"
              }
            >
              <Button
                variant="contained"
                label="New Tile"
                icon={<Add />}
                color="primary"
                onClick={() => {
                  dispatch(setSelectedDashboard(id));
                  dispatch(selectTile(undefined));
                  navigate(`/add-tile`);
                }}
              />
              <Button
                variant="contained"
                label="New Dashboard"
                icon={<Add />}
                color="secondary"
                onClick={() => {
                  dispatch(setSelectedDashboard(id));
                  dispatch(selectTile(undefined));
                  navigate(`/add-dashboard`);
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardHeaderView;
